const GOAL_WIZARD_STORAGE_KEY = "goalWizard";

const REFINE_STATS_KEYS = [
  "avgSalePrice",
  "avgCommission",
  "pendingToCloseRatio",
  "sellerToTotalClosingsRatio",
  "brokerageSplitPercentage",
  "brokerageCap",
  "royaltyPercentage",
  "royaltyCap",
  "sellerCommissionSplit",
  "buyerCommissionSplit",
];

export const pickRefineStats = (goals) =>
  Object.fromEntries(
    REFINE_STATS_KEYS.filter((key) => goals[key] !== undefined).map((key) => [key, goals[key]]),
  );

export const readWizardStorage = () => {
  try {
    return JSON.parse(localStorage.getItem(GOAL_WIZARD_STORAGE_KEY) || "{}") || {};
  } catch {
    return {};
  }
};

export const updateWizardStorage = (update) => {
  const current = readWizardStorage();
  const next = { ...current, ...update(current) };
  localStorage.setItem(GOAL_WIZARD_STORAGE_KEY, JSON.stringify(next));
  return next;
};

const scopeKey = (agentId, year) => `${year}:${String(agentId ?? "self")}`;

export const saveScopedWizardValue = (agentId, year, section, values, modified) =>
  updateWizardStorage((current) => ({
    scopedValues: {
      ...current.scopedValues,
      [scopeKey(agentId, year)]: {
        ...current.scopedValues?.[scopeKey(agentId, year)],
        [section]: { values, modified },
      },
    },
  }));

export const readScopedWizardValue = (agentId, year, section) =>
  readWizardStorage().scopedValues?.[scopeKey(agentId, year)]?.[section] ?? null;
